import React from "react";
import { tono } from "./tonos";

/**
 * Barras horizontales por categoría del kit de tableros (por tipo, por
 * responsable, por cliente...). Cada barra es un drill-down.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 * @param {string} titulo    Kicker de la tarjeta
 * @param {string} subtitulo Texto pequeño bajo el kicker
 * @param {Array} filas      [{clave, etiqueta, valor, sufijo, tonoxxx, nota}]
 * @param {function} onFila  Drill-down (recibe la fila)
 * @param {string} vacio     Texto cuando no hay filas
 * @param {number} maxFilas  Filas visibles antes del scroll (default 6)
 */
const Barrasxx = ({ titulo, subtitulo, filas = [], onFila, vacio = "Sin datos", maxFilas = 6 }) => {
  const max = Math.max(1, ...filas.map((f) => Number(f.valor) || 0));
  return (
    <div className="tbl-card">
      <span className="tbl-kicker">{titulo}</span>
      {subtitulo && <span className="tbl-kpi-nota">{subtitulo}</span>}
      {filas.length === 0 && <span className="tbl-estado">{vacio}</span>}
      <div className="tbl-barras" style={{ maxHeight: maxFilas * 26 }}>
        {filas.map((f) => {
          const t = tono(f.tonoxxx);
          return (
            <div
              key={f.clave}
              className={`tbl-barra ${onFila ? "clic" : ""}`}
              onClick={() => onFila?.(f)}
              title={f.nota ?? (onFila ? "Ver en su pantalla" : undefined)}
            >
              <span className="tbl-barra-etiqueta">{f.etiqueta}</span>
              <div className="tbl-barra-pista">
                <div className="tbl-barra-relleno" style={{ width: `${Math.max(2, Math.round(((Number(f.valor) || 0) / max) * 100))}%`, background: t.hex }} />
              </div>
              <span className="tbl-barra-valor">
                {f.valor}
                {f.sufijo && <span style={{ fontWeight: 400, color: "#A3A3A3" }}>{f.sufijo}</span>}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Barrasxx;
